// Shared look & behaviour for every Room to Escape screen (reference Desktop UI).
import React, { useEffect, useState } from "react";
import "./escapeShared.css";

/** old/*.php's right-click / devtools-shortcut block. */
export function useDisableInspect() {
  useEffect(() => {
    const blockContextMenu = (event) => event.preventDefault();
    const blockShortcutKeys = (e) => {
      const blocked =
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
        (e.ctrlKey && e.keyCode === 85); // Ctrl+U
      if (blocked) e.preventDefault();
    };
    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("keydown", blockShortcutKeys);
    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("keydown", blockShortcutKeys);
    };
  }, []);
}

const MOBILE_QUERY = "(max-width: 768px) and (orientation: portrait)";

/** Phones held upright get the mob_* creatives and room_mob layout. */
export function useMobileLayout() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches
  );
  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const sync = () => setIsMobile(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);
  return isMobile;
}

/** Paints a full-bleed scene on <body>, switching to the mobile art upright. */
export function useSceneBackground(desktopUrl, mobileUrl = desktopUrl) {
  const isMobile = useMobileLayout();
  const url = isMobile ? mobileUrl : desktopUrl;
  useEffect(() => {
    const body = document.body;
    const prev = {
      backgroundImage: body.style.backgroundImage,
      backgroundSize: body.style.backgroundSize,
      backgroundRepeat: body.style.backgroundRepeat,
      backgroundPosition: body.style.backgroundPosition,
      backgroundAttachment: body.style.backgroundAttachment,
    };
    body.classList.remove("common-bg");
    body.style.backgroundImage = `url("${url}")`;
    body.style.backgroundSize = "cover";
    body.style.backgroundRepeat = "no-repeat";
    body.style.backgroundPosition = "center center";
    body.style.backgroundAttachment = "fixed";
    return () => Object.assign(body.style, prev);
  }, [url]);
  return isMobile;
}

/** Red-and-gold plank button (img/button.png). */
export function PirateButton({ children, className = "", ...props }) {
  return (
    <button type="button" className={`pirate-btn ${className}`} {...props}>
      <span>{children}</span>
    </button>
  );
}

/** Parchment card: "sheet" = img/letter1.png, "scroll" = img/letter2.png. */
export function Parchment({ variant = "sheet", className = "", children }) {
  return <div className={`parchment parchment--${variant} ${className}`}>{children}</div>;
}
